import { render, staticRenderFns } from "./endorsementQuotation.vue?vue&type=template&id=67740515&scoped=true&"
import script from "./endorsementQuotation.vue?vue&type=script&lang=js&"
export * from "./endorsementQuotation.vue?vue&type=script&lang=js&"
import style0 from "./endorsementQuotation.vue?vue&type=style&index=0&id=67740515&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67740515",
  null
  
)

export default component.exports